import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { collection, query, where, getDocs } from "firebase/firestore";
import { firestore } from "../../firebase/firebase";
import "../styles/login.css";

const Login = ({ setUser }) => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const usersRef = collection(firestore, "users");
      const q = query(usersRef, where("username", "==", username));
      const querySnapshot = await getDocs(q);

      if (querySnapshot.empty) {
        throw new Error("User not found");
      }

      let userData = null;
      querySnapshot.forEach((doc) => {
        userData = { id: doc.id, ...doc.data() };
      });

      if (!userData) {
        throw new Error("User data not found");
      }

      if (userData.password !== password) {
        throw new Error("Incorrect password");
      }

      // Set user in App component state
      setUser({ id: userData.id, username: userData.username });

      // Store user in localStorage
      localStorage.setItem(
        "user",
        JSON.stringify({ id: userData.id, username: userData.username })
      );

      // Navigate to dashboard
      navigate("/dashboard/home");
    } catch (err) {
      setError("Incorrect Username or Password.");
      console.error("Login Error:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-custom">
      <form className="container bg-login" onSubmit={handleSubmit}>
        <h2 className="mb-5">Login</h2>
        <div className="form-group">
          <label htmlFor="username">Username</label>
          <input
            type="text"
            className="form-control"
            id="username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="password">Password</label>
          <input
            type="password"
            className="form-control"
            id="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>
        {error && <div className="text-danger mb-3">{error}</div>}

        <button
          type="submit"
          className="btn btn-primary"
          disabled={loading || username === "" || password === ""}
        >
          {loading ? "Logging in..." : "Login"}
        </button>
      </form>
    </div>
  );
};

export default Login;
